<script lang="ts">export let isAuthenticated = false;
</script>

<aside id="collapsible-sidebar" class="overlay [--body-scroll:true] border-base-content/20 overlay-open:translate-x-0 drawer drawer-start sm:overlay-layout-open:translate-x-0 hidden w-64 border-e [--auto-close:sm] [--is-layout-affect:true] [--opened:lg] sm:absolute sm:z-0 sm:flex sm:shadow-none lg:[--overlay-backdrop:false]" role="dialog" tabindex="-1" >

    <div class="flex justify-end">
        <button type="button" class="btn btn-text btn-square" aria-haspopup="dialog" aria-expanded="false" aria-controls="collapsible-sidebar" data-overlay="#collapsible-sidebar" >
            <span class="icon-[tabler--x] size-5"></span>
        </button>
    </div>
    <div class="drawer-header flex items-center gap-3 justify-center">
        <img src="/img/logo.svg" alt="Logo Paaspop Den Hout"/>
    </div>
    <div class="drawer-body px-2 pt-4">
        <ul class="menu p-0">
            <li>
                <a href="/">
                    <span class="icon-[tabler--calendar] size-5"></span>
                    Werkschema
                </a>
            </li>
            <li>
                <a href="/rewards">
                    <span class="icon-[tabler--award] size-5"></span>
                    Beloningen
                </a>
            </li>
            <li>
                <a href="/merchandise">
                    <span class="icon-[tabler--gift] size-5"></span>
                    Goodies
                </a>
            </li>
            {#if isAuthenticated}
                <li>
                    <a href="/volunteer">
                        <span class="icon-[tabler--user] size-5"></span>
                        Vrijwilligers
                    </a>
                </li>
                <li>
                    <a href="/logout">
                        <span class="icon-[tabler--logout-2] size-5"></span>
                        Uitloggen
                    </a>
                </li>
            {:else}
                <li>
                    <a href="/login">
                        <span class="icon-[tabler--login] size-5"></span>
                        Inloggen
                    </a>
                </li>
            {/if}
        </ul>
    </div>
</aside>

<div class="sm:overlay-layout-open:ps-64 min-h-full bg-base-100 transition-all duration-300">
    <!-- Navigation Toggle -->
    <div class="px-2">
        <button type="button" class="btn btn-text btn-square" aria-haspopup="dialog" aria-expanded="false" aria-controls="collapsible-sidebar" data-overlay="#collapsible-sidebar" >
            <span class="icon-[tabler--menu-2] size-5"></span>
        </button>
    </div>
    <!-- End Navigation Toggle -->
</div>
